import React from "react";

const FooterBtns = () => {
  return (
    <div className="d-flex  w-100 gap-5 footerBtns">
      <a
        href="https://wa.me/+917990201423"
        target="_blank"
        rel="noopener noreferrer"
        className={
          window.location.pathname === "/about"
            ? "btnContacts btn btn-warning AboutBtn"
            : "btnContacts btn btn-warning AboutBtn"
        }
      >
        Chat With Us
      </a>
      <a href="tel:+9179902 01423" className= {
          window.location.pathname === "/about"
            ? "btnContacts btn btn-warning AboutBtn"
            : "btnContacts btn btn-warning AboutBtn"
        }>
        Call Us
      </a>
    </div>
  );
};

export default FooterBtns;
